import React from 'react';
import styled from 'styled-components';
import {darkGrayColor} from '../../../../../ui/constants/colors';
import {
  fontSize12,
  fontSize18,
  fwBold,
  fwSemiBold,
  lhL,
} from '../../../../../ui/constants/typography';

export const EventHeader: React.FC<{title: string; subtitle: string}> = ({
  title,
  subtitle,
}) => {
  return (
    <EventList>
      <EventListSubtitle>{subtitle}</EventListSubtitle>
      <EventListTitle>{title}</EventListTitle>
    </EventList>
  );
};

const EventList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 38px 0 30px 0;
`;

const EventListSubtitle = styled.div`
  ${fontSize12};
  ${fwSemiBold};
  text-transform: uppercase;
  color: ${darkGrayColor};
  letter-spacing: 0.3px;
  line-height: ${lhL};
`;

const EventListTitle = styled.div`
  ${fontSize18};
  ${fwBold};
  padding-top: 4px;
`;
